var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sp-rich-text"},[_c('VueHtml5Editor',{attrs:{"content":_vm.value},on:{"change":_vm.updateData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }